module.exports = __webpack_public_path__ + "img/milborne.8718f20b.svg";